<template>
  <component :is="authComponent" />
</template>

<script lang="ts" setup>
import AuthEmailForm from '@web/platform.v3/views/auth/auth-email-form.vue'
import AuthEmailCode from '@web/platform.v3/views/auth/auth-email-code.vue'
import AuthPhoneForm from '@web/platform.v3/views/auth/auth-phone-form.vue'
import AuthPhoneCode from '@web/platform.v3/views/auth/auth-phone-code.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from '@web/store'

defineOptions({
  name: 'AuthByPage'
})

const route = useRoute()
const authType = computed(() => (route.params.type as 'email' | 'phone') ?? 'email')
const store = useStore()
const emailStatus = computed(() => store.getters['authV3/emailStatus'])
const phoneStatus = computed(() => store.getters['authV3/phoneStatus'])

const authComponent = computed(() => {
  if (authType.value === 'email') {
    if (emailStatus.value === 'code') {
      return AuthEmailCode
    }

    return AuthEmailForm
  }

  if (authType.value === 'phone') {
    if (phoneStatus.value === 'code') {
      return AuthPhoneCode
    }
    return AuthPhoneForm
  }

  return AuthEmailForm
})
</script>
